
import { ChangeDetectorRef, Component, ViewEncapsulation, inject } from '@angular/core';
import { ButtonComponent } from '../generic-button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';

@Component({
  selector: 'lib-grid-reset-header',
  templateUrl: './ag-grid-reset-header.component.html',
  styleUrls: ['./ag-grid-reset-header.component.scss'],
  imports: [ButtonComponent, TranslateModule, UpperCasePipe],
  encapsulation: ViewEncapsulation.None
})
export class AgGridResetHeaderComponent {
  params: any;
  isDisabled = true;
  private readonly cdr = inject(ChangeDetectorRef);

  agInit(params: unknown): void {
    this.params = params;
    
    this.updateButtonState();

    this.params.api.addEventListener('filterChanged', () => this.updateButtonState());
    this.params.api.addEventListener('sortChanged', () => this.updateButtonState());

  }

  resetColumns() {
    const api = this.params.api;

    // Clears the model + checkbox selections and re-runs filtering
    api.setFilterModel(null);

    api.getColumns()?.forEach((col: { getColId: () => string }) =>
      api.destroyFilter(col.getColId())
    );

    api.applyColumnState({
      defaultState: { sort: null }
    });
  }

  
  updateButtonState() {
    const api = this.params.api;
    const hasFilter = api.getFilterModel() && Object.keys(api.getFilterModel()).length > 0;
    const hasSorting = api.getColumnState().some((col: { sort: null; }) => col.sort != null);

    this.isDisabled = !(hasFilter || hasSorting);
    this.cdr.detectChanges();
  }

}
